import { Component, output, input, InputSignal, computed } from '@angular/core';
import { ClientSite } from 'src/app/models/clientsite';
import {
    MatCheckboxChange,
    MatCheckboxModule
} from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

export type SitePermissionsChanged = {
    permittedSiteIds: Array<number>;
};

@Component({
    selector: 'app-site-permission-editor-v2',
    standalone: true,
    imports: [CommonModule, MatIconModule, MatCheckboxModule],
    templateUrl: './site-permission-editor-v2.component.html',
    styleUrls: ['./site-permission-editor-v2.component.scss']
})
export class SitePermissionEditorV2Component {
    permittedSiteIds: InputSignal<Array<number>> =
        input.required<Array<number>>();
    allSites: InputSignal<Array<ClientSite>> =
        input.required<Array<ClientSite>>();
    defaultSite: InputSignal<number | undefined> = input<number>();
    sitePermissionChanged = output<SitePermissionsChanged>();

    allSelected = computed(() => {
        const allSites = this.allSites();
        const permittedSiteIds = this.permittedSiteIds();

        if (allSites.length === permittedSiteIds.length) {
            return true;
        }

        return false;
    });

    selectAllSite(event: MatCheckboxChange) {
        if (event.checked) {
            this.sitePermissionChanged.emit({
                permittedSiteIds: this.allSites().map((i) => i.siteId)
            });
            return;
        }

        this.sitePermissionChanged.emit({
            permittedSiteIds: []
        });
    }

    toggleSite(siteId: number, checked: boolean) {
        if (!checked) {
            this.sitePermissionChanged.emit({
                permittedSiteIds: this.permittedSiteIds().filter(
                    (i) => i !== siteId
                )
            });
            return;
        }

        this.sitePermissionChanged.emit({
            permittedSiteIds: [...new Set([...this.permittedSiteIds(), siteId])]
        });
    }
}
